import { ELEMENTS } from "@tSurya/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        iconProps: {
            css: css`
                svg {
                    width: ${ELEMENTS.selectIconSize};
                    height: ${ELEMENTS.selectIconSize};
                }
            `,
        },
    },
};
